import { Component, OnInit, Inject, Input, ChangeDetectionStrategy,ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { FormService } from 'src/app/shared/dhl-form/services/form.service';
import { APP_Constants } from '../../app.constant'
import { CustomSnackBarService } from '../snack-bar/snack-bar.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ModalConfigData } from 'src/app/common/modalconfig/modalconfig';

export const saveUserSubject = new Subject<boolean>();

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ModalComponent implements OnInit, AfterViewInit {

  public subject: Subject<boolean>;
  showModalForm: boolean = false;
  enum = ModalConfigData;
  isValueExist = false;
  isErrorMessage = false;
  customerClass = '';
  constructor(private _snackBar: CustomSnackBarService, private formService: FormService, private appService: AppService, public dialogRef: MatDialogRef<ModalComponent>, @Inject(MAT_DIALOG_DATA) public modalData: any, private cdRef:ChangeDetectorRef, public translate: TranslateService) {
    console.log(modalData);
  }

  getColsClass(cols: number[]) {
    const mediaBreakpoints = ['xl', 'lg', 'md', 'sm', 'xs'];
    let colsClass = '';
    for (let i = 0; i < cols.length; i++) {
      colsClass += 'col-' + mediaBreakpoints[i] + '-' + cols[i] + ' ';
    }
    return colsClass;
  }

  config: any;
  upperConfig: any;
  formGroupUpper:any;
  formGroup: any;
  position: number;
  editMode: boolean = false;
  eventobserver: Subscription;
  configControlls: any;
  disableDefaultSaveButton = Boolean(this.modalData?.modalForm?.template?.disableDefaultSaveButton);

  ngOnInit() {
    if (this.modalData.modalForm) {
      this.config = this.modalData.modalForm.template;
      this.formGroup = this.modalData.modalForm.frmGroup;
      this.position = this.modalData.modalForm.position;
      this.editMode = this.modalData.modalForm.editMode;
      this.configControlls = this.config?.controls;
    }

    if(this.modalData.actionbuttonclosetext){
      this.modalData.actionbuttonclosetext=this.modalData.actionbuttonclosetext
      }
      else{
      this.modalData.actionbuttonclosetext=this.enum.BUTTONS.BUTTONCLOSE
    }

    // Set customer-specific CSS class
    const customerName = localStorage.getItem('customerName');
    this.customerClass = customerName !== 'COX Automotive' ? 'non-cox-customer' : '';
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  getFormTableControls() {
    return this.formGroup.controls;
  }

  actionFunction() {
    if (this.subject) {
      this.subject.next(true);
      this.subject.complete();
    }
    this.dialogRef.close(true);
  }

  closeModal() {
    if (this.subject) {
      this.subject.next(false);
      this.subject.complete();
    }
    this.dialogRef.close(false);
  }

  saveShipmentDetails(e) {
    e.preventDefault();
    if (this.formGroup.invalid) {
      this.formService.validateAllFormFields(this.formGroup);
      return false;
    }
    this.appService.newEvent({ 'value': this.formGroup.value, 'position': this.position, 'editMode': this.editMode });
    if (this.subject) {
      this.subject.next(true);
      this.subject.complete();
    }
    this.dialogRef.close(true);
  }

  CancelShipment() {
    if (this.subject) {
      this.subject.next(false);
      this.subject.complete();
    }
    if (!this.editMode) {
      this.formGroup.reset();
    }
    this.dialogRef.close(false);
  }
  saveAddNewUser(e) {
    let allowSecondary=(this.formGroup.allowSecondaryRoles ? this.formGroup.allowSecondaryRoles: false)
    e.preventDefault();

    const invalid = [];
    const controls = this.formGroup.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    if(invalid.length > 0) {
     this.formService.validateAllFormFields(this.formGroup);
      return false;
    }

    let url = APP_Constants.ADMIN_MAINTAIN_USERS_URI + localStorage.getItem('userName');
    let data = this.formGroup.getRawValue();

    let me = this;
    data.userRole = data.userRole.value;

    if (data.secondaryUserRoles) {
      data.secondaryUserRoles = data.secondaryUserRoles.toString();
    }

    let modifiedPayload = {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      customerCode: data.customerCode.value,
      role: data.userRole,
      secondaryRoles: (allowSecondary ? (data.secondaryUserRoles ? data.secondaryUserRoles : '') : '')
    }
    let dataRestrictionsDependentFields = this.formGroup?.dataRestrictionsDependentFields;
    if (Array.isArray(dataRestrictionsDependentFields) && dataRestrictionsDependentFields?.length > 0) {
      modifiedPayload['dataRestrictions'] = {}
      dataRestrictionsDependentFields.forEach(res => {
        console.log(res, res.dataRestrictionKey, "<==res")
        modifiedPayload['dataRestrictions'][res.dataRestrictionKey] = data[res.dataRestrictionKey];
      });
    } else {
      modifiedPayload['dataRestrictions'] = (data.dataRestrictions ? data.dataRestrictions.toString() : '')
    }
    //let dynamicPayload = 

    this.dialogRef.close(true);

    // Send loading signal to listeners
    saveUserSubject.next(true);

     this.appService.makeHttpPostRequest(url, modifiedPayload).subscribe((response) => {
       this._snackBar.open({ orderId: '', message: response['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });
       me.appService._commonSubjecct.next(data);
     }, err => {
       this._snackBar.open({ orderId: '', message: err['message'] }, { duration: this.durationInSeconds * 1000 });
     }, () => {
      // Complete
      saveUserSubject.next(false);
     });

  }
  savUsertDetails(e) {
    let allowSecondary=(this.formGroup.allowSecondaryRoles ? this.formGroup.allowSecondaryRoles: false)
    e.preventDefault();

    const invalid = [];
    const controls = this.formGroup.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }

    if(invalid.length > 0) {
      this.formService.validateAllFormFields(this.formGroup);
      return false;
    }

    let url = APP_Constants.ADMIN_UPDAT_USERS_URI + localStorage.getItem('userName');
    let data = this.formGroup.getRawValue();
    let me = this;
    data.userRole = data.userRole.value
    let modifiedPayload = {
      userName: data.email,
      userCustomerSubscription:{
        customerCode: data.customerCode,
        userRole: data.userRole,
        secondaryUserRoles: (allowSecondary ? (data.secondaryUserRoles ? data.secondaryUserRoles : '') : ''),
        email:data.email
      }
    }
    let dataRestrictionsDependentFields = this.formGroup?.dataRestrictionsDependentFields;
    if (Array.isArray(dataRestrictionsDependentFields) && dataRestrictionsDependentFields?.length > 0) {
      modifiedPayload.userCustomerSubscription['dataRestrictions'] = {}
      dataRestrictionsDependentFields.forEach(res => {
        modifiedPayload.userCustomerSubscription['dataRestrictions'][res.dataRestrictionKey] = data[res.dataRestrictionKey];
      });
    } else {
      modifiedPayload.userCustomerSubscription['dataRestrictions'] = (data.dataRestrictions ? data.dataRestrictions.toString() : '')
    }

    this.appService.makeHttpPutRequest(url, modifiedPayload).subscribe((response) => {

      this._snackBar.open({ orderId: '', message: response['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });
      me.appService._commonSubjecct.next(data);
      this.dialogRef.close(true);

    }, err => {
      this.dialogRef.close(true);
      this._snackBar.open({ orderId: '', message: err['message'] }, { duration: this.durationInSeconds * 1000 });
    });
  }
  durationInSeconds = 20;

  /**
   *
   * @param event : string {Submit | Cancel }
   * @param formGroup : FormGroup
   * @param modalData : Object<any>{}
   *
   * 1. OnSubmit of common form it will send data back to where modal created
   * 2. modalData.name should be unique to identify If more than one subscriber available in same screen
   */
  onSubmitEvent(event, formGroup, modalData) {
    if (modalData.action == false) {
      this.dialogRef.close(true);
      return;
    }

    let data = {
      event: event,
      name: modalData.name,
      formValue: this.formGroup.getRawValue()
    }
    
    Object.keys(data.formValue).forEach(control => {
      const controlValue = this.formGroup.get(control).value;
      console.log(typeof controlValue, controlValue);
      const isObjValConvert = this.config?.controls?.filter(({ name, objValConvert }) => name === control && objValConvert);
      if(typeof controlValue === 'object' && Boolean(isObjValConvert?.length)) {
        data.formValue[control] = data.formValue[control].value;
      }
    });
    this.appService._modalCommonFormSubjecct.next(data);
  }

  onCloseModalEvent(event, formGroup, modalData) {
    if (modalData.action == false) {
      this.dialogRef.close(true);
      return;
    }
    let data = {
      event: event,
      name: modalData.name,
      formValue: this.formGroup.getRawValue()
    }
    this.appService._modalCommonFormSubjecct.next(data);
    this.dialogRef.close(true);
  }

  onCloseFilterModal(event, formGroup, modalData) {
    this.isValueExist = false;
    this.isErrorMessage = false;
    if(event === 'save') {
      let isPresent = false;
      let isValue = Object.keys(formGroup.getRawValue()).some(k => this.formGroup.value[k])
      if(isValue) {
        if(this.formGroup.get('newFilterName').value && modalData.modalForm.fieldOptions && modalData.modalForm.fieldOptions.length) {
          let data = modalData.modalForm.fieldOptions;
          isPresent = data.find(item => {
            if(item.queryName && (item.queryName.toLowerCase().trim() === this.formGroup.get('newFilterName').value.toLowerCase().trim())) {
              return true;
            }
          });
        }
        if(isPresent) {
          this.isValueExist = true;
        } else {
          this.onCloseModalEvent(event, formGroup, modalData);
        }
      } else {
        this.isErrorMessage = true;
      }
    } else {
      this.onCloseModalEvent(event, formGroup, modalData)
    }
  }
 
  onSubmitEventCancelOrderFn(event, modalData) {
    if (modalData.action == false) {
      this.dialogRef.close(true);
      return;
    }
    let data = {
      event: event,
      name: modalData.name,
      clickEventData : modalData.modalForm.clickEventData,
    }
    this.appService._modalCommonFormSubjecct.next(data)
  }
}
